export default __webpack_public_path__ + "static/media/industry-bold.f8985697.ttf";